import React, { FunctionComponent, memo } from 'react';
import styles from '../../OrderStatusPage.module.scss';
import { useTranslation } from 'react-i18next';
import { OrderStatusTrackerFigure } from './components/OrderStatusTrackerFigure';
import { type OrderGuestStatuses } from 'plugins/CheckoutPlugin/types/CheckoutTypes';
import { useLocationStore } from 'mycheck-core';
import { observer } from 'mobx-react';
import { Spacer } from '@components';

interface OrderStatusTrackerProps {
  orderStatusesDate: OrderGuestStatuses[];
}

const OrderStatusTracker = observer<FunctionComponent<OrderStatusTrackerProps>>(
  ({ orderStatusesDate }) => {
    const { t } = useTranslation();
    const LocationStore = useLocationStore();
    const subtitle = LocationStore.guestOrderStatusMessage?.order_disclaimer;

    return (
      <>
        <div className={styles.orderStatusPageSectionTitle}>
          {t('orderStatus.figure.title')}
        </div>
        <div className={styles.orderStatusPageSectionSubtitle}>
          {subtitle || t('orderStatus.statusMessages.orderDisclaimer')}
        </div>
        <OrderStatusTrackerFigure orderStatusesDate={orderStatusesDate} />
        <Spacer color="#C6C6C6" />
      </>
    );
  },
);

export default memo(OrderStatusTracker);
